/**
 * @file 接口
 */
import { getUrlSearchValue, getDecodeValue } from "@/utils";
import request, { BASE_URL } from "./axios";

// const BASE_URL_MOCK = 'https://yapi.inner.youdao.com/mock/730'

import { AddressInfo } from "./address";

export interface CourseItem {
  courseId: number;
  courseName: string;
}

// 获取题目信息
export const getCourseList = () => {
  const { ccId, studentId } = getUrlSearchValue();
  return request(`${BASE_URL}/course-selection/toc/course/listSourseCourse`, {
    params: {
      coachUserId: getDecodeValue(ccId),
      userId: studentId,
      key: "mhd",
    },
  }) as Service.FetchResponse<{
    sourceCourses: CourseItem[];
  }>;
};

export interface ClassItem {
  courseId: number;
  courseName: string;
  teacherName: string;
  studentNum: number;
  hasMaterial: boolean;
  selected: boolean;
  startTime: string;
  endTime: string;
}

export const getClassList = ({ courseId }: { courseId: number }) => {
  const { studentId, ccId } = getUrlSearchValue();
  return request(`${BASE_URL}/course-selection/toc/course/courseList`, {
    params: {
      courseId,
      userId: studentId,
      key: "mhd",
      coachId: getDecodeValue(ccId),
    },
  }) as Service.FetchResponse<{
    courses: ClassItem[];
    remainSelections: number;
    hasSelected: boolean;
  }>;
};

export const submitCourse = ({
  courseId,
  courseIdSelected,
  address,
}: {
  courseId: number;
  courseIdSelected: number;
  address?: AddressInfo;
}) => {
  const { studentId, ccId } = getUrlSearchValue();
  return request(`${BASE_URL}/course-selection/toc/course/enter`, {
    method: "POST",
    params: {
      userId: studentId,
      key: "mhd",
    },
    data: {
      courseId,
      courseIdSelected,
      address,
      coachId: getDecodeValue(ccId),
    },
  }) as Promise<{
    code: number;
    msg: string;
    data: any;
  }>;
};
